import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
import * as db from '@/core/Database'
import { UserManager } from "@/services/UserManager"
import appManager from '@/services/AppManager'
import { Log } from "@/services/Log"
import vuetify from '@/plugins/vuetify'
import { SubscriptionsManager } from '@/services/SubscriptionsManager'
import { AlertManager } from '@/services/AlertManager'
import { UserCompanyManager } from '@/services/UserCompanyManager'
import { CompanyManager } from "@/services/CompanyManager"

const log = new Log('main')

log.info('Initializing Firebase')

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXNqk-X7o2dvyNaYgHTIm2fd6ZhzxXmU8",
  authDomain: "dewald-academy-of-drying.firebaseapp.com",
  databaseURL: "https://dewald-academy-of-drying.firebaseio.com",
  projectId: "dewald-academy-of-drying",
  storageBucket: "dewald-academy-of-drying.appspot.com",
  messagingSenderId: "160983372662",
  appId: "1:160983372662:web:37af452f852efe051f2057",
  measurementId: "G-B71FB8EQCN"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

db.initializeDatabase(firebase.firestore())

log.info('Initializing App')
const userManager = new UserManager()
const userCompanyManager = new UserCompanyManager(userManager)
appManager.initialize(
    userManager,
    userCompanyManager,
    new CompanyManager(userCompanyManager),
    new SubscriptionsManager(),
    new AlertManager()
)

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
